import React from "react";
import { Box } from "@chakra-ui/react";
import { useCurrentCase } from "duck";
import { DentalChartEnum, SpeciesEnum } from "requests";
import { TOOTH_STATE_TO_BORDER, TOOTH_STATE_TO_COLOR } from "../../duck";
import {
  CatAdultJaw,
  CatDeciduousJaw,
  DogAdultJaw,
  DogDeciduousJaw,
  RabbitJaw
} from "./components";

const Jaw: React.FC = () => {
  const { species, dentalChartings, milkOrAdultTeeth } = useCurrentCase(
    ({ data }) => ({
      species: data.client.patient.species || null,
      dentalChartings: data.client.patient.dentalChartings,
      milkOrAdultTeeth:
        data.client.patient.generalAssessment?.dentalChart || null
    })
  );

  /* eslint-disable no-param-reassign */
  React.useEffect(() => {
    const allTeeth = Array.from(
      document.querySelectorAll("path[data-tooth]")
    ) as HTMLElement[];

    allTeeth.forEach(tooth => {
      const dataValue = tooth.dataset.tooth;
      if (!dataValue) {
        return;
      }

      const chart = dentalChartings?.find(cht => cht.tooth === +dataValue);

      if (chart) {
        if (tooth.hasAttribute("fill")) {
          tooth.style.fill =
            TOOTH_STATE_TO_COLOR[chart.toothState || ""] || "#9AD6FF";
        }
        tooth.style.stroke =
          TOOTH_STATE_TO_BORDER[chart.toothState || ""] || "#8592BF";
      }
    });
  }, [dentalChartings]);
  /* eslint-enable */

  const charts: {
    [species in SpeciesEnum]?: { [chart in DentalChartEnum]: JSX.Element };
  } = {
    [SpeciesEnum.Cat]: {
      [DentalChartEnum.Deciduous]: <CatDeciduousJaw />,
      [DentalChartEnum.Adult]: <CatAdultJaw />
    },
    [SpeciesEnum.Dog]: {
      [DentalChartEnum.Deciduous]: <DogDeciduousJaw />,
      [DentalChartEnum.Adult]: <DogAdultJaw />
    }
  };

  return !species || !milkOrAdultTeeth ? null : (
    <Box m="0 auto" w="75%">
      {charts[species] ? charts[species]?.[milkOrAdultTeeth] : <RabbitJaw />}
    </Box>
  );
};

export default Jaw;
